import { render, staticRenderFns } from "./docked-foldout.vue?vue&type=template&id=394392aa&scoped=true&"
import script from "./docked-foldout.vue?vue&type=script&lang=ts&"
export * from "./docked-foldout.vue?vue&type=script&lang=ts&"
import style0 from "./docked-foldout.vue?vue&type=style&index=0&id=394392aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394392aa",
  null
  
)

export default component.exports